import LoginMain from "../../main/modules/User/pages/Login/Login";
import PasswordReset from "../../main/modules/User/pages/PasswordReset";
import PasswordForget from "../../main/modules/User/pages/PasswordForget";

const userLayoutRoutes = [
    {
        path: "login",
        name: "LoginMain",
        component: LoginMain,
        meta: { isGuest:true }
    },
    {
        path: "password/reset",
        name: "PasswordResetUser",
        component: PasswordReset,
        meta: { isGuest: true }
    },
    {
        path: "password/forget",
        name: "PasswordForgetUser",
        component: PasswordForget,
        meta: { isGuest: true }
    },

]

export default userLayoutRoutes;